import React, { useEffect, useState, useRef } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import {
  getOpenMicContests,
  getAllContests,
  getOfflineOpenMics,
  getRegistrations,
  getAnyProfileDetails,
  getSimpleEvents,
  getSimpleEventSubEventDetail,
  getStoryDrafts,
  getPoemDrafts,
} from "./utilities/ApiCalls";
import { getTokenDetails } from "./utilities/CommonFunction";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { getResponsiveImage } from "../utils/responsiveImage";
import { CopyIcon, ChevronLeft, ChevronRight } from "lucide-react";

const Constant = require("./Constant");

const Events = () => {
  const [t] = useTranslation();
  const [openMicEvents, setOpenMicEvents] = useState([]);
  const [openMic, setOpenMic] = useState([]);
  const [offlineOpenMics, setOfflineOpenMics] = useState([]);
  const [contestData, setContestData] = useState([]);
  const [simpleEvents, setSimpleEvents] = useState([]);
  const [error, setError] = useState(null);
  const [offlineError, setOfflineError] = useState(null);
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const [meetlinks, setMeetLinks] = useState({});
  const [popup, setPopup] = useState(false);
  const [passcode, setPasscode] = useState("");
  const [showmeet, setShowMeet] = useState(false);
  const [formError, setFormError] = useState(null);
  const [user, setUser] = useState({});
  const [isContestDraftModalOpen, setIsContestDraftModalOpen] = useState(false);
  const [contestDraftStep, setContestDraftStep] = useState("choose");
  const [contestDrafts, setContestDrafts] = useState([]);
  const [selectedContestDraftId, setSelectedContestDraftId] = useState("");
  const [contestDraftError, setContestDraftError] = useState("");
  const [loadingContestDrafts, setLoadingContestDrafts] = useState(false);
  const [draftContestMeta, setDraftContestMeta] = useState({
    contestType: "story",
    contestId: "",
    language: "English",
  });

  // Refs for each slider
  const contestsSliderRef = useRef(null);
  const eventsSliderRef = useRef(null);
  const openMicSliderRef = useRef(null);
  const simpleEventsSliderRef = useRef(null);

  const [currentSlide, setCurrentSlide] = useState({
    events: 0,
    openMic: 0,
    contests: 0,
    offlineOpenMics: 0,
    simpleEvents: 0,
  });
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return format(date, "do MMM yyyy 'at' hh.mm aaaa ('IST')", {
      locale: enUS,
    });
  };

  const getContestIdFromDraft = (draft) => {
    if (!draft || !draft.contestId) return "";
    if (typeof draft.contestId === "string") return draft.contestId;
    if (typeof draft.contestId === "object" && draft.contestId._id) {
      return draft.contestId._id;
    }
    return "";
  };

  const resetContestDraftModal = () => {
    setIsContestDraftModalOpen(false);
    setContestDraftStep("choose");
    setContestDrafts([]);
    setSelectedContestDraftId("");
    setContestDraftError("");
    setLoadingContestDrafts(false);
    setDraftContestMeta({
      contestType: "story",
      contestId: "",
      language: "English",
    });
  };

  const openContestDraftModal = ({ contestType, contestId, language }) => {
    setDraftContestMeta({
      contestType,
      contestId,
      language: language || "English",
    });
    setContestDraftStep("choose");
    setContestDrafts([]);
    setSelectedContestDraftId("");
    setContestDraftError("");
    setLoadingContestDrafts(false);
    setIsContestDraftModalOpen(true);
  };

  const loadContestDrafts = async () => {
    setContestDraftStep("draft");
    setLoadingContestDrafts(true);
    setContestDraftError("");
    setSelectedContestDraftId("");
    try {
      const resp =
        draftContestMeta.contestType === "story"
          ? await getStoryDrafts({ contestId: draftContestMeta.contestId })
          : await getPoemDrafts({ contestId: draftContestMeta.contestId });

      if (resp.status === "Success") {
        const filteredDrafts = (resp.data || []).filter(
          (draft) =>
            getContestIdFromDraft(draft) === String(draftContestMeta.contestId),
        );
        setContestDrafts(filteredDrafts);
      } else {
        setContestDraftError(resp.message || "Unable to load drafts.");
      }
    } catch (e) {
      setContestDraftError("Unable to load drafts.");
    } finally {
      setLoadingContestDrafts(false);
    }
  };

  const goToContestEntry = ({ draftId = "" } = {}) => {
    const basePath =
      draftContestMeta.contestType === "story" ? "/contest-story" : "/contest-poem";
    const query = new URLSearchParams({
      contestId: draftContestMeta.contestId,
      language: draftContestMeta.language || "English",
    });

    if (draftId) {
      query.set("id", draftId);
      query.set("isDraft", "1");
    }

    history.push(`${basePath}?${query.toString()}`);
    resetContestDraftModal();
  };
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  useEffect(() => {
    const token = localStorage.getItem("loginDetails");
    // console.log(token);
    const fetchStream = async () => {
      try {
        const { data } = await axios.get(
          `${Constant.apiBasePath}openMic/getContestLinks`,
          {
            headers: { token: token },
          },
        );
        await setMeetLinks(data.data[0]);
        // console.log(data.data[0]);
      } catch (error) {
        console.error("Error fetching user stream:", error);
        setErrorMessage(error.message);
      }
    };
    const fetchUser = async () => {
      let token = localStorage.getItem("loginDetails");
      const { _id } = getTokenDetails(token);
      try {
        const res = await getAnyProfileDetails(_id);
        // console.log(res.data.data);
        setUser(res.data.data);
      } catch (error) {
        console.error("Error fetching user token:", error);
      }
    };
    fetchUser();

    fetchStream();
  }, []);

  const handleJoin = () => {
    // You can add passcode validation logic here if needed
    if (passcode === meetlinks.codeZoomLink) {
      toast("correct passcode");
      setPasscode("");
      setShowMeet(true);
    } else {
      toast("wrong passcode try again ");
      setPasscode("");
    }
  };

  // Function to combine date and time into a Date object
  const getDateTime = (date, time) => {
    const [year, month, day] = date.split("-").map(Number);
    const [hour, minute] = time.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute);
  };

  // Function to sort contests
  const sortContests = (contests) => {
    return contests.sort((a, b) => {
      const dateTimeA = getDateTime(a.startDate, a.startTime);
      const dateTimeB = getDateTime(b.startDate, b.startTime);
      return dateTimeB - dateTimeA; // Descending order
    });
  };

  useEffect(() => {
    const fetchOpenMicEvents = async () => {
      try {
        // console.log("Fetching Koral Open Mics...");
        const openMicEventsResult = await getRegistrations();
        // console.log("Resistrations:", openMicEventsResult.data);

        setOpenMicEvents(openMicEventsResult.data.data);
      } catch (err) {
        setError("Error fetching Koral Open Mic events: " + err.message);
        console.error("Error fetching Koral Open Mic events:", err);
      }
    };
    const sortByDate = (data) => {
      return data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    };

    const fetchOpenMicContests = async () => {
      try {
        const openMicContestsResult = await getOpenMicContests();
        if (openMicContestsResult.status === "Success") {
          // console.log("Open Mic Events Set:", openMicContestsResult.data); // Log the data
          const sortedContests = openMicContestsResult.data.sort((a, b) => {
            const dateTimeA = new Date(`${a.createdAt}`);
            const dateTimeB = new Date(`${b.createdAt}`);
            return dateTimeB - dateTimeA;
          });
          setOpenMic(sortedContests);
          // console.log("sorted ", sortedContests);
        } else {
          setError(openMicContestsResult.message);
        }
      } catch (err) {
        setError("Error fetching Open Mic contests: " + err.message);
      }
    };

    const fetchOfflineOpenMics = async () => {
      try {
        // console.log("Fetching Offline Open Mics...");
        const offlineOpenMicsResult = await getOfflineOpenMics();
        // console.log("Offline Open Mics Response:", offlineOpenMicsResult);

        const activeOfflineOpenMics = offlineOpenMicsResult.data.filter(
          (mic) => mic.active === 1,
        );
        setOfflineOpenMics(activeOfflineOpenMics);
      } catch (err) {
        setOfflineError("Error fetching Offline Open Mics: " + err.message);
        console.error("Error fetching Offline Open Mics:", err);
      }
    };

    const fetchContests = async () => {
      try {
        // console.log("Fetching Contests...");
        const allContestsResult = await getAllContests({});
        // console.log("Contests Response:", allContestsResult);

        if (allContestsResult.status === "Success") {
          const sortedContests = allContestsResult.data.sort((a, b) => {
            const dateTimeA = new Date(`${a.startDate}T${a.startTime}`);
            const dateTimeB = new Date(`${b.startDate}T${b.startTime}`);
            return dateTimeB - dateTimeA;
          });
          setContestData(sortedContests);
        }
      } catch (err) {
        setError("Error fetching contests: " + err.message);
        console.error("Error fetching contests:", err);
      }
    };

    const fetchSimpleEvents = async () => {
      try {
        // console.log("Fetching Simple Events...");
        const simpleEventsResult = await getSimpleEvents();
        // console.log("Simple Events Response:", simpleEventsResult);

        const sortedSimpleEvents = simpleEventsResult.data.sort((a, b) => {
          const dateTimeA = new Date(`${a.createdAt}`);
          const dateTimeB = new Date(`${b.createdAt}`);
          return dateTimeB - dateTimeA;
        });
        setSimpleEvents(sortedSimpleEvents);
      } catch (err) {
        setError("Error fetching Simple Events: " + err.message);
        console.error("Error fetching Simple Events:", err);
      }
    };

    fetchOpenMicEvents();
    fetchOpenMicContests();
    fetchOfflineOpenMics();
    fetchContests();
    fetchSimpleEvents();
  }, []);

  const handleContestClick = async (
    languageu,
    contestId,
    contestName,
    contestType,
  ) => {
    const contest = contestData.find((c) => c._id === contestId);
    if (contest) {
      const startDateTime = new Date(
        `${contest.startDate}T${contest.startTime}`,
      );
      const language = languageu || "English";
      const closureDateTime = new Date(
        `${contest.closureDate}T${contest.closureTime}`,
      );
      const resultDateTime = new Date(
        `${contest.resultDate}T${contest.resultTime}`,
      );
      const currentDateTime = new Date();

      if (
        currentDateTime >= closureDateTime &&
        currentDateTime <= resultDateTime
      ) {
        history.push({
          pathname:
            contestType === "story"
              ? `/contestStories/${contestId}`
              : `/contestPoetries/${contestId}`,
          search: `?resultDate=${resultDateTime}&noVoting=${!!contest.noVoting}`,
        });
      } else if (
        currentDateTime >= startDateTime &&
        currentDateTime <= closureDateTime
      ) {
        const token = localStorage.getItem("loginDetails");
        const userDetails = token ? getTokenDetails(token) : {};
        try {
          const endpoint =
            contestType === "story" ? "story/filter" : "poem/filter";

          const response = await axios.get(
            `${Constant.apiBasePath}${endpoint}?contestId=${contestId}`,
          );

          const stories = response.data;
          const userIdMatched = stories.some(
            (story) =>
              story.userId === userDetails._id && story.isDraft === false,
          );
          if (userIdMatched) {
            setErrorMessage("Story already submitted");

            setTimeout(() => {
              setErrorMessage("");
            }, 3000);
          } else {
            openContestDraftModal({
              contestType,
              contestId,
              language,
            });
          }
        } catch (error) {
          console.error("Error fetching stories:", error);
        }
      } else if (currentDateTime > resultDateTime) {
        history.push({
          pathname: `/contest-result/${contestId}/${contestType}`,
          state: { contestName },
        });
      }
    }
  };

  const handleAfterChange = (carousel, index) => {
    setCurrentSlide((prevState) => ({
      ...prevState,
      [carousel]: index,
    }));
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false, // Commented out - arrows not properly aligned
  };

  const handleGo = async (id) => {
    try {
      const token = await localStorage.getItem("loginDetails");
      const userId = await getTokenDetails(token);
      const response = await axios.post(
        `${Constant.apiBasePath}user-responses/check-submission?userId=${userId._id}&formId=${id}`,
      );
      // console.log(response.data.submitted);
      if (response.data.submitted) {
        setFormError("Form already submitted");

        setTimeout(() => {
          setFormError("");
        }, 3000);
        return;
      } else {
        history.push({
          pathname: `/EventForm/${id}`,
          state: { EventId: id },
        });
      }
      // history.push({
      //   pathname: `/EventForm/${"67555af97e0be8083e8e9cae"}`,
      //   state: { EventId: "67555af97e0be8083e8e9cae" },
      // });
    } catch (error) {
      // console.log("error");
    }
  };

  const formUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSc6pj6ODipF2efqVT_sKODwsc0VNWuto5jjMFYe7_WMMA68aw/closedform";

  const handleSimpleEventClick = async (event) => {
    if (
      event.subEventsCount === 1 &&
      event.subEvents &&
      event.subEvents.length > 0
    ) {
      try {
        // Fetch details for all subevents
        const subEventDetails = await Promise.all(
          event.subEvents.map((id) => getSimpleEventSubEventDetail(id)),
        );
        // Find the active subevent (status === 1 or active === true)
        const activeSubEvent = subEventDetails.find(
          (detail) =>
            detail.data &&
            (detail.data.status === 1 || detail.data.active === true),
        );
        if (activeSubEvent && activeSubEvent.data && activeSubEvent.data._id) {
          history.push({
            pathname: `/simple-sub-event/${activeSubEvent.data._id}`,
            state: { subEventId: activeSubEvent.data._id },
          });
          return;
        }
      } catch (err) {
        // Optionally handle error (e.g., show a toast)
        console.error("Error fetching subevent details", err);
      }
      // Fallback: go to the simple event page if no active subevent found
      history.push({
        pathname: `/simple-event/${event._id}`,
        state: { eventId: event._id },
      });
    } else if (event.subEventsCount > 1) {
      history.push({
        pathname: `/simple-event/${event._id}`,
        state: { eventId: event._id },
      });
    }
  };

  return (
    <Layout>
      <Container>
        {/* <Section>
          <Heading>Open Mic Offline Event</Heading>
          {error ? (
            <Error>{error}</Error>
          ) : (
            <SliderContainer>
              <Slider
                {...settings}
                afterChange={(index) =>
                  handleAfterChange("offlineOpenMics", index)
                }
              >
                {offlineOpenMics.map((mic) => (
                  <SliderItem>
                    <Link to={`/OpenMicOfflineParticipantForm/?id=${mic._id}`}>
                      <Image
                        src="https://cdn-icons-png.freepik.com/512/7067/7067447.png"
                        alt={mic.name}
                      />
                      <Title>{mic.name}</Title>
                      <Subtitle>{mic.location}</Subtitle>
                    </Link>
                  </SliderItem>
                ))}
              </Slider>
            </SliderContainer>
          )}
        </Section> */}
        {meetlinks.active && (
          <StreamSection>
            <div className="livestream">
              {/* <h1>LiveStreaming</h1> */}
              {/* {meetlinks.livestreamingLink ? (
                <iframe
                  className="video"
                  credentialless="true"
                  src={`https://www.youtube.com/embed/${meetlinks.livestreamingLink}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <p>Loading livestream...</p>
              )} */}

              <button className="joinButton" onClick={() => setPopup(true)}>
                Join Event
              </button>
            </div>

            {/* Popup for passcode */}
            {popup && (
              <div className="popup">
                <div className="popup-content">
                  <div className="link" style={{ padding: "20px" }}>
                    <p
                      style={{
                        fontSize: "20px",
                        color: "var(--color-text-tertiary)",
                      }}
                    >
                      Meet Link:{" "}
                      <a
                        href={`https://${meetlinks.zoomLink.replace(
                          /^https?:\/\//,
                          "",
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "var(--color-text-tertiary)" }}
                      >
                        {meetlinks.zoomLink}
                      </a>
                    </p>

                    <button
                      className="clbtn"
                      onClick={() => (setPopup(false), setShowMeet(false))}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* Popup for passcode
            {popup && (
              <div className="popup">
                <div className="popup-content">
                  {showmeet ? (
                    <div className="link" style={{ padding: "20px" }}>
                      <p style={{ fontSize: "20px", color: "white" }}>
                        Meet Link :{" "}
                        <a href={`${meetlinks.zoomLink}`} target="_blank">
                          {meetlinks.zoomLink}
                        </a>
                      </p>
                      <button
                        className="clbtn"
                        onClick={() => (setPopup(false), setShowMeet(false))}
                      >
                        Close
                      </button>
                    </div>
                  ) : (
                    <>
                      <h2>Enter Passcode</h2>
                      <input
                        type="text"
                        value={passcode}
                        onChange={(e) => setPasscode(e.target.value)}
                        placeholder="Enter passcode"
                      />
                      <div className="btnContainer">
                        <button className="btn" onClick={handleJoin}>
                          Submit
                        </button>
                        {errorMessage && (
                          <p style={{ color: "red" }}>{errorMessage}</p>
                        )}
                        <button className="btn" onClick={() => setPopup(false)}>
                          Close
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )} */}
          </StreamSection>
        )}

        {/* //button for meetings  */}
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link to={`/Storytent-Meeting`}>
            <JoinButton onClick={() => {}}>Join Meeting</JoinButton>
          </Link>
        </div> */}
        {/* {user.email == "mrao27488@gmail.com" && 
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link to={`/Create-Meeting`}>
              <CreateButton onClick={() => {}}>Create Meeting</CreateButton>
            </Link>
          </div>
        } */}
        {contestData.length > 0 && (
          <Section>
            <Heading>{t("Events.Contests")}</Heading>
            {errorMessage && <Error>{errorMessage}</Error>}
            <CarouselWrapper>
              <NavButton
                onClick={() => contestsSliderRef.current?.slickPrev()}
                aria-label="Previous slide"
              >
                <ChevronLeft size={24} />
              </NavButton>
              <SliderContainer>
                <Slider
                  ref={contestsSliderRef}
                  {...settings}
                  afterChange={(index) => handleAfterChange("contests", index)}
                >
                  {contestData.map((contest, index) => {
                    const currentDateTime = new Date();
                    const startDateTime = new Date(
                      `${contest.startDate}T${contest.startTime}`,
                    );
                    const closureDateTime = new Date(
                      `${contest.closureDate}T${contest.closureTime}`,
                    );
                    const resultDateTime = new Date(
                      `${contest.resultDate}T${contest.resultTime}`,
                    );

                    return (
                      <SliderItem
                        key={contest._id}
                        onClick={() =>
                          handleContestClick(
                            contest.language,
                            contest._id,
                            contest.name,
                            contest.type,
                          )
                        }
                      >
                        <Image
                          src={getResponsiveImage(
                            contest.mobileImage,
                            contest.image ||
                              "https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                          )}
                          alt={contest.name}
                        />
                        <Title>{contest.name}</Title>
                        <Subtitle>
                          {currentDateTime >= startDateTime &&
                          currentDateTime <= closureDateTime ? (
                            // Contest is live
                            <span>{t("Events.ContestIsLive")}</span>
                          ) : currentDateTime > closureDateTime &&
                            currentDateTime < resultDateTime ? (
                            // Voting period between closureDateTime and resultDateTime
                            <span>{t("Events.VotingPeriod")}</span>
                          ) : currentDateTime < startDateTime ? (
                            // Contest has not started yet
                            <span>
                              {t("Events.ContestStartOn")}{" "}
                              {formatDateTime(
                                contest.startDate + " " + contest.startTime,
                              )}
                            </span>
                          ) : (
                            // Contest has ended
                            <span>{t("Events.ContestEnd")}</span>
                          )}
                        </Subtitle>
                      </SliderItem>
                    );
                  })}
                </Slider>
              </SliderContainer>
              <NavButton
                onClick={() => contestsSliderRef.current?.slickNext()}
                aria-label="Next slide"
              >
                <ChevronRight size={24} />
              </NavButton>
            </CarouselWrapper>
          </Section>
        )}
        {isContestDraftModalOpen && (
          <DraftModalBackdrop>
            <DraftModal>
              <DraftCloseButton onClick={resetContestDraftModal}>x</DraftCloseButton>
              <DraftTitle>
                {draftContestMeta.contestType === "story"
                  ? "Continue your contest story"
                  : "Continue your contest poem"}
              </DraftTitle>
              {contestDraftStep === "choose" && (
                <>
                  <DraftText>
                    Would you like to start something new or continue from a draft?
                  </DraftText>
                  <DraftActions>
                    <DraftButtonPrimary onClick={() => goToContestEntry()}>
                      Start New{" "}
                      {draftContestMeta.contestType === "story" ? "Story" : "Poem"}
                    </DraftButtonPrimary>
                    <DraftButtonSecondary onClick={loadContestDrafts}>
                      Choose a Draft
                    </DraftButtonSecondary>
                  </DraftActions>
                </>
              )}
              {contestDraftStep === "draft" && (
                <>
                  {loadingContestDrafts ? (
                    <DraftText>Loading drafts...</DraftText>
                  ) : contestDrafts.length === 0 ? (
                    <DraftText>
                      No drafts found for this contest. You can start a new one.
                    </DraftText>
                  ) : (
                    <>
                      <DraftLabel>Select a draft to continue:</DraftLabel>
                      <DraftSelect
                        value={selectedContestDraftId}
                        onChange={(e) => setSelectedContestDraftId(e.target.value)}
                      >
                        <option value="">Select a draft</option>
                        {contestDrafts.map((draft) => (
                          <option key={draft._id} value={draft._id}>
                            {draft.name || "(Untitled)"}{" "}
                            {draft.updatedAt
                              ? `- ${new Date(draft.updatedAt).toLocaleString()}`
                              : ""}
                          </option>
                        ))}
                      </DraftSelect>
                    </>
                  )}
                  <DraftActions>
                    <DraftButtonPrimary
                      disabled={!selectedContestDraftId}
                      onClick={() => {
                        if (!selectedContestDraftId) return;
                        goToContestEntry({ draftId: selectedContestDraftId });
                      }}
                    >
                      Continue
                    </DraftButtonPrimary>
                    <DraftButtonSecondary
                      onClick={() => {
                        setContestDraftStep("choose");
                        setSelectedContestDraftId("");
                        setContestDraftError("");
                      }}
                    >
                      Back
                    </DraftButtonSecondary>
                  </DraftActions>
                </>
              )}
              {contestDraftError && <DraftError>{contestDraftError}</DraftError>}
            </DraftModal>
          </DraftModalBackdrop>
        )}

        {/* <Section>
          <Heading>{t("Events.KoralOpenMics")}</Heading>
          {error ? (
            <Error>{error}</Error>
          ) : (
            <SliderContainer>
              <Slider
                {...settings}
                afterChange={(index) => handleAfterChange("events", index)}
              >
                {openMicEvents.map((event, index) => (
                  <SliderItem
                    key={event._id}
                    onClick={() =>
                      window.open(event.url, "_blank", "noopener,noreferrer")
                    }
                  >
                    <Image
                      src="https://t3.ftcdn.net/jpg/01/15/40/12/360_F_115401245_GYPbMWpOT59rUcfObToRcFjyF2KFYIAe.jpg"
                      alt={event.name}
                    />
                    <Title>{event.name}</Title>
                  </SliderItem>
                ))}
              </Slider>
            </SliderContainer>
          )}
        </Section> */}

        {openMicEvents.filter((event) => event.active === true).length > 0 && (
          <Section>
            <Heading>{t("Events.Registrations")}</Heading>
            {formError && <Error>{formError}</Error>}
            {error ? (
              <Error>{error}</Error>
            ) : (
              <CarouselWrapper>
                <NavButton
                  onClick={() => eventsSliderRef.current?.slickPrev()}
                  aria-label="Previous slide"
                >
                  <ChevronLeft size={24} />
                </NavButton>
                <SliderContainer>
                  <Slider
                    ref={eventsSliderRef}
                    {...settings}
                    afterChange={(index) => handleAfterChange("events", index)}
                  >
                    {openMicEvents
                      .filter((event) => event.active === true)
                      .map((event) => (
                        <SliderItem
                          key={event._id}
                          onClick={() => handleGo(event._id)}
                        >
                          <Image
                            src={getResponsiveImage(
                              event.mobileImage,
                              event.thumbnail,
                            )}
                            alt={event.name}
                          />
                          <Title>{event.name}</Title>
                        </SliderItem>
                      ))}
                  </Slider>
                </SliderContainer>
                <NavButton
                  onClick={() => eventsSliderRef.current?.slickNext()}
                  aria-label="Next slide"
                >
                  <ChevronRight size={24} />
                </NavButton>
              </CarouselWrapper>
            )}
          </Section>
        )}

        {openMic.length > 0 && (
          <Section>
            <Heading>{t("Events.OpenMic")}</Heading>
            <CarouselWrapper>
              <NavButton
                onClick={() => openMicSliderRef.current?.slickPrev()}
                aria-label="Previous slide"
              >
                <ChevronLeft size={24} />
              </NavButton>
              <SliderContainer>
                <Slider
                  ref={openMicSliderRef}
                  {...settings}
                  afterChange={(index) => handleAfterChange("openMic", index)}
                >
                  {openMic.map((data, index) => (
                    <Link to={`/openmic/${data._id}`} key={data._id}>
                      <SliderItem>
                        <Image
                          src={getResponsiveImage(data.mobileImage, data.image)}
                          alt={data.name}
                        />
                        <Title>{data.name}</Title>
                      </SliderItem>
                    </Link>
                  ))}
                </Slider>
              </SliderContainer>
              <NavButton
                onClick={() => openMicSliderRef.current?.slickNext()}
                aria-label="Next slide"
              >
                <ChevronRight size={24} />
              </NavButton>
            </CarouselWrapper>
          </Section>
        )}

        {simpleEvents.filter((event) => event.subEventsCount > 0).length >
          0 && (
          <Section>
            <Heading>{t("Events.SpecialEvents") || "Special Events"}</Heading>
            {error ? (
              <Error>{error}</Error>
            ) : (
              <CarouselWrapper>
                <NavButton
                  onClick={() => simpleEventsSliderRef.current?.slickPrev()}
                  aria-label="Previous slide"
                >
                  <ChevronLeft size={24} />
                </NavButton>
                <SliderContainer>
                  <Slider
                    ref={simpleEventsSliderRef}
                    {...settings}
                    afterChange={(index) =>
                      handleAfterChange("simpleEvents", index)
                    }
                  >
                    {simpleEvents
                      .filter((event) => event.subEventsCount > 0) // Only render events with at least 1 subevent
                      .map((event, index) => (
                        <SliderItem
                          key={event._id}
                          onClick={() => handleSimpleEventClick(event)}
                        >
                          <Image
                            src={getResponsiveImage(
                              event.mobileImage,
                              event.image ||
                                "https://images.unsplash.com/photo-1485579149621-3123dd979885?q=80&w=1631&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                            )}
                            alt={event.name}
                          />
                          <Title>{event.name}</Title>
                        </SliderItem>
                      ))}
                  </Slider>
                </SliderContainer>
                <NavButton
                  onClick={() => simpleEventsSliderRef.current?.slickNext()}
                  aria-label="Next slide"
                >
                  <ChevronRight size={24} />
                </NavButton>
              </CarouselWrapper>
            )}
          </Section>
        )}
        <Toaster />
      </Container>
    </Layout>
  );
};
const JoinButton = styled.button`
  background-color: #4687d3;
  color: var(--color-surface);
  width: 110px;
  height: 40px;
  border-radius: 10px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CreateButton = styled.button`
  background-color: #4687d3;
  color: var(--color-surface);
  width: 150px;
  height: 40px;
  border-radius: 10px;
  margin-top: 20px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SliderItem = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  width: 100%; /* Ensure it takes full width */
  aspect-ratio: 700/400; /* Maintain 700x400 aspect ratio */
  max-width: 700px; /* Maximum width to maintain aspect ratio */
  margin: 0 auto; /* Center the slider item */
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform 0.5s ease,
    box-shadow 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background: #1a1a1a; /* Background color for letterboxing */

  @media (max-width: 768px) {
    max-width: 100%; /* Allow full width on tablets */
    aspect-ratio: 700/400; /* Maintain aspect ratio */
  }

  @media (max-width: 480px) {
    max-width: 100%; /* Allow full width on mobile */
    aspect-ratio: 700/400; /* Maintain aspect ratio */
    border-radius: 8px; /* Smaller border radius for mobile */
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }

  &.active {
    transform: scale(1.05);
    z-index: 1;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  &:hover {
    opacity: 0.9;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto; /* Maintain aspect ratio */
  object-fit: cover;
  border-radius: 12px;

  @media (max-width: 768px) {
    height: 100%; /* Fill container height on tablets */
    width: 100%;
  }

  @media (max-width: 480px) {
    height: 100%; /* Fill container height on mobile */
    width: 100%;
  }
`;

const Title = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: var(--color-text-secondary);
  font-size: 1.2em;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 1em; /* Adjust font size for smaller screens */
    left: 10px; /* Adjust position for smaller screens */
    bottom: 50px; /* Ensure it doesn't overlap with the subtitle */
  }
`;

const Subtitle = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: var(--color-text-secondary);
  font-size: 0.9em;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 0.8em; /* Adjust font size for smaller screens */
    left: 10px; /* Adjust position for smaller screens */
    bottom: 10px; /* Ensure it fits well with the title */
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 30px;
  height: 100vh;
  min-height: fit-content;
  box-sizing: border-box;
`;

const Section = styled.section`
  margin-bottom: 60px;
`;
const StreamSection = styled.section`
  margin-bottom: 60px;
  width: 50%; /* Default width for larger screens */
  margin: 0 auto;

  input {
    display: inline-block;
    width: 80%;
    height: 25%;
    padding: 10px;
    border-radius: 10px;
    font-size: 16px;
    letter-spacing: 1px;
  }
  p {
    text-align: center;
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); /* Reduced opacity */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Ensure it's on top of everything */
  }
  .btnContainer {
    display: flex;
    gap: 28px;
    justifycontent: center;
    alignitems: center;
    paddingtop: 10px;
  }
  .popup-content {
    background-color: #0f1817;
    width: 40%;
    height: 24%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;

    .clbtn {
      width: 40%;
      height: 5vh;
      border: 1px solid gray;
      background-color: white;
      border-radius: 10px;
    }

    .btn {
      width: 100%;
      height: 5vh;
      border: 1px solid gray;
      background-color: white;
      border-radius: 10px;
    }
  }

  /* Input styling */

  .livestream {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 40px;
  }

  .joinButton {
    padding: 4px;
    width: 10vw;
    height: 6vh;
    font-weight: bold;
    background: #212121;
    color: var(--color-text-tertiary);
    border: 1px solid black;
    border-radius: 5px;
  }
  .video {
    width: 566px;
    height: 400px;
  }
  .link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    width: 70%; /* Adjust width for tablets if needed */

    .btnContainer {
      gap: 28px;
    }

    .popup-content {
      width: 70%;
      height: 25%;

      .btn {
        width: 70%;
        height: 6vh;
      }
    }
    input {
      height: 27%;
    }

    .video {
      width: 120%;
      height: 400px;
    }

    .joinButton {
      padding: 4px;
      width: 21vw;
      height: 6vh;
    }
  }

  @media (max-width: 480px) {
    width: 80%; /* Adjust width for mobile devices */
    .btnContainer {
      gap: 28px;
    }

    .popup-content {
      width: 82%;
      height: 25%;

      .btn {
        width: 70%;
        height: 6vh;
      }
    }

    input {
      height: 30%;
    }
    .video {
      width: 120%;
      height: 300px;
    }

    .joinButton {
      padding: 4px;
      width: 30vw;
      height: 6vh;
    }
  }
`;

const Heading = styled.h1`
  font-size: 2.2em;
  color: var(--color-text);
  text-align: center;
  margin-bottom: 20px;
`;

const Error = styled.div`
  color: red;
  text-align: center;
  font-size: 1.3em;
  margin: 40px 0;
`;

const SliderContainer = styled.div`
  width: 100%; /* Full width to accommodate aspect ratio */
  max-width: 700px; /* Maximum width to maintain 700x400 ratio */
  margin: 0 auto; /* Center the container */

  @media (max-width: 768px) {
    width: 90%; /* Slightly smaller on tablets */
    max-width: 100%; /* Allow full width on smaller screens */
  }

  @media (max-width: 480px) {
    width: 95%; /* Almost full width on mobile */
    max-width: 100%; /* Allow full width on mobile */
  }
`;

const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 5px;
  }
`;

const NavButton = styled.button`
  background: #808080;
  border: 1px solid #707070;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  z-index: 10;

  svg {
    color: #ffffff;
  }

  &:hover {
    background: #909090;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const DraftModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;

const DraftModal = styled.div`
  position: relative;
  width: 90%;
  max-width: 480px;
  background: var(--color-surface);
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
`;

const DraftCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;
  border: none;
  background: transparent;
  color: var(--color-text);
  font-size: 20px;
  cursor: pointer;
`;

const DraftTitle = styled.h2`
  margin: 0 0 10px;
  color: var(--color-text-tertiary);
  font-size: 22px;
`;

const DraftText = styled.p`
  margin: 0 0 16px;
  color: var(--color-text);
  font-size: 14px;
`;

const DraftActions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const DraftBaseButton = styled.button`
  flex: 1;
  min-width: 140px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
`;

const DraftButtonPrimary = styled(DraftBaseButton)`
  background: var(--color-text-tertiary);
  color: var(--color-surface);
  border-color: var(--color-text-tertiary);

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

const DraftButtonSecondary = styled(DraftBaseButton)`
  background: transparent;
  color: var(--color-text-tertiary);
`;

const DraftLabel = styled.label`
  display: block;
  margin: 8px 0 6px;
  color: var(--color-text-tertiary);
  font-size: 13px;
  font-weight: 500;
`;

const DraftSelect = styled.select`
  width: 100%;
  margin-bottom: 12px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 9px 10px;
  color: var(--color-text);
  background: var(--color-surface);
`;

const DraftError = styled.p`
  margin-top: 10px;
  color: #c0392b;
  font-size: 13px;
`;

export default Events;
